<template>
  <div class="boxTB">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        placeholder="请输入关键字（年级/学科/地区/类型/年份）"
        path="/layout/list/listenBig"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>
    <!-- 模块1 -->
    <div class="box-taobao1">
      <!-- 学科筛选按钮 -->
      <subjectButton
        :filterButton="mydata.filterButton1"
        @change="change1"
        :key="mydata.testKey0"
        style="margin-bottom: 10px"
      ></subjectButton>
      <subjectButton
        :filterButton="mydata.filterButton2"
        @change="change2"
        style="margin-bottom: 10px"
        :key="mydata.testKey1"
      ></subjectButton>
      <subjectButton
        :filterButton="mydata.filterButton3"
        @change="change3"
        :key="mydata.testKey2"
        style="margin-bottom: 10px"
      ></subjectButton>
      <subjectButton
        :filterButton="mydata.filterButton4"
        @change="change4"
        :key="mydata.testKey3"
        style="margin-bottom: 10px"
      ></subjectButton>
      <subjectButton
        :filterButton="mydata.filterButton5"
        :key="mydata.testKey4"
        @change="change5"
      ></subjectButton>
    </div>
    <!--模块2 -->
    <div class="box-taobao2">
      <!-- 最新上传  -->
      <!-- <column
        title="最新上传"
        path="/layout/list/listenBig"
        :routeQuery="{ is_new: 1 }"
      >
        <template #abc>
          <ul>
            <li
              class="my-li hover-change-color"
              v-for="(item, index) in mydata.new_list.list"
              :key="index"
              @click="goInfoPage(item.id)"
            >
              <p>{{ item.title }}</p>
              <p class="hover-change-color">
                {{ item.create_time.slice(0, 10) }}
              </p>
            </li>
          </ul>
        </template>
      </column> -->

      <realExamQuestions
        title="最新上传"
        path="/layout/list/listenBig"
        pathDetail="/layout/list/topicSubjectDetails"
        :routeQuery="{ is_new: 1 }"
        :info="mydata.new_list.list"
      >
      </realExamQuestions>

      
      <!-- 数据一览 -->
      <dataOverview :obj="mydata.grade_count"></dataOverview>
    </div>

    <!--模块3————高考真题、中考真题 -->
    <!-- <div class="box-taobao3">
      <column
        title="高考真题"
        path="/layout/list/listenBig"
        :routeQuery="{ grade_id: 171 }"
      >
        <template #abc>
          <ul>
            <li
              class="my-li hover-change-color"
              v-for="(item, index) in mydata.grade_lists['高考']"
              :key="index"
              @click="goInfoPage(item.id)"
            >
              <p>{{ item.title }}</p>
              <p>{{ item.create_time.slice(0, 10) }}</p>
            </li>
          </ul>
        </template>
      </column>
      <column
        title="中考真题"
        path="/layout/list/listenBig"
        :routeQuery="{ grade_id: 170 }"
      >
        <template #abc>
          <ul>
            <li
              class="my-li hover-change-color"
              v-for="(item, index) in mydata.grade_lists['中考']"
              :key="index"
              @click="goInfoPage(item.id)"
            >
              <p>{{ item.title }}</p>
              <p>{{ item.create_time.slice(0, 10) }}</p>
            </li>
          </ul>
        </template>
      </column>
    </div> -->

    <!--模块4 ————高一、高二、高三-->
    <div class="box-taobao4">
      <div class="book-list">
        <el-tabs
          v-model="mydata.activeName"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="高一试题"
            name="first"
            :routeQuery="{ grade_id: 167 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['高一']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane
            label="高二试题"
            name="second"
            :routeQuery="{ grade_id: 168 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['高二']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane
            label="高三试题"
            name="third"
            :routeQuery="{ grade_id: 169 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['高三']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--模块5 ————初一、初二、初三 -->
    <div class="box-taobao5">
      <div class="book-list">
        <el-tabs
          v-model="mydata.activeName2"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="初一试题"
            name="first"
            :routeQuery="{ grade_id: 164 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['初一']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane
            label="初二试题"
            name="second"
            :routeQuery="{ grade_id: 165 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['初二']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane
            label="初三试题"
            name="third"
            :routeQuery="{ grade_id: 166 }"
          >
            <ul>
              <li
                class="my-li hover-change-color"
                v-for="(item, index) in mydata.grade_lists['初三']"
                :key="index"
                @click="goInfoPage(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{ item.create_time }}</p> -->
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--模块6  -->
    <div class="box-taobao6">
      <img src="@/assets/qwer.png" alt="" />
      <!-- 轮播图图片组件 -->
      <swiperImg
        v-if="mydata.recommend_list.length"
        :dataArr="mydata.recommend_list"
        @itemClick="itemClick"
        :key="mydata.testKey5"
      ></swiperImg>
    </div>
  </div>
</template>


<script>
// 是否来自其他模块
let fromOtherModule = false;
//缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "boutiqueTaobaoQuestions",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      ["/layout/list/listenBig", "/layout/list/topicSubjectDetails"].includes(
        from.path
      ) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>


<script setup>
import swiperImg from "@/components/swiperImg/index.vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";

import column from "@/components/column/index.vue";

import realExamQuestions from "@/components/realExamQuestions/index.vue";

import dataOverview from "@/components/dataOverview/index.vue";

import { useRouter, useRoute } from "vue-router";

import { reactive, onActivated } from "vue";

//引入淘题首页接口
import { examIndex } from "@/api/boutiqueTaobaoQuestions/index.js";
// 引入淘题搜索接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";

// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { dictKeyWord } from "@/utils/dict.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  activeName: "first",
  activeName2: "first",
  //筛选按钮
  filterButton1: {
    title: "年级",
    filter: JSON.parse(localStorage.getItem("grade_list")) ?? [],
  },
  filterButton2: {
    title: "学科",
    filter: JSON.parse(localStorage.getItem("subject_list")) ?? [],
  },
  filterButton3: {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("address_list")) ?? [],
  },
  filterButton4: {
    title: "类型",
    filter: JSON.parse(localStorage.getItem("type_list")) ?? [],
  },
  filterButton5: {
    title: "年份",
    filter: JSON.parse(localStorage.getItem("year_list2")) ?? [],
  },
  testKey0: new Date().getTime() - Math.random() * 10,
  testKey1: new Date().getTime() - Math.random() * 100,
  testKey2: new Date().getTime() - Math.random() * 1000,
  testKey3: new Date().getTime() - Math.random() * 10000,
  testKey4: new Date().getTime() - Math.random(),
  testKey5: new Date().getTime() - Math.random() * 100000,

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询

    grade_id: "", // 年级
    subject_id: "", //学科
    address_id: "", //地区
    type_id: "", //类型
    year_id: "", // 年份
    is_new: "", //是否最新（不传或者传0：否，1：是）
    is_recommended: "", //是否推荐（不传或者传0：否，1：是）
  },
  new_list: {}, // 最新上传
  recommend_list: {}, //推荐列表
  grade_lists: {}, //年级数据列表
  grade_count: {}, //年级数字
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.activeName= "first";
    mydata.activeName2= "first";
    //筛选按钮
    mydata.filterButton1 = {
      title: "年级",
      filter: JSON.parse(localStorage.getItem("grade_list")) ?? [],
    };
    mydata.filterButton2 = {
      title: "学科",
      filter: JSON.parse(localStorage.getItem("subject_list")) ?? [],
    };
    mydata.filterButton3 = {
      title: "地区",
      filter: JSON.parse(localStorage.getItem("address_list")) ?? [],
    };
    mydata.filterButton4 = {
      title: "类型",
      filter: JSON.parse(localStorage.getItem("type_list")) ?? [],
    };
    mydata.filterButton5 = {
      title: "年份",
      filter: JSON.parse(localStorage.getItem("year_list2")) ?? [],
    };

    mydata.testKey0 = new Date().getTime() - Math.random() * 10;
    mydata.testKey1 = new Date().getTime() - Math.random() * 100;
    mydata.testKey2 = new Date().getTime() - Math.random() * 1000;
    mydata.testKey3 = new Date().getTime() - Math.random() * 10000;
    mydata.testKey4 = new Date().getTime() - Math.random();
    mydata.form = {
      // column_id: getUrlId(route.path), // 栏目id值
      search: "", // 搜索查询

      grade_id: "", // 年级
      subject_id: "", //学科
      address_id: "", //地区
      type_id: "", //类型
      year_id: "", // 年份
      is_new: "", //是否最新（不传或者传0：否，1：是）
      is_recommended: "", //是否推荐（不传或者传0：否，1：是）
    };
    mydata.new_list = {}; // 最新上传
    mydata.recommend_list = {}; //推荐列表
    mydata.grade_lists = {}; //年级数据列表
    mydata.grade_count = {}; //年级数字

    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getBottomRecommendData();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  if (localStorage.getItem("v") !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1;
    mydata.form.search = localStorage.getItem("v"); // 获取本地存储并且赋值
    localStorage.removeItem("v"); // 赋值后立刻删除本地存储内容
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getBottomRecommendData();
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    getData();
    // getData()
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }

  // 注意：绑定给swiper轮播图的key变量，不要 写在if(fromOtherModule){}里面，而是写在它的外面，因为不管是不是其他模块跳转过来的还是自己模块后退过来的，都要重新赋值这个绑定给swiper的key变量
  mydata.testKey5 = new Date().getTime() - Math.random() * 100000;
});

function topicButton() {
  router.push({
    path: "/layout/list/topicSubjectDetails",
  });
}

//////////////////////////////
// 查询列表
function queryList(dict, inputValue) {
  // 赋值
  mydata.form.search = inputValue;

  // 获取页面数据
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
  // 查询
  // articleListFn();
}
//////////////////////////////

// 获取页面数据
function getData() {
  // 调用接口
  examIndex(mydata.form).then((res) => {
    // console.log(res.data,"淘题首页");
    mydata.new_list = res.data.new_list;
    // mydata.recommend_list = res.data.recommend_list;
    mydata.grade_lists = res.data.grade_lists;
    mydata.grade_count = res.data.grade_count;
  });
}

function itemClick(val) {
  let path = val.buy_url_jd || val.buy_url;
  if (path) {
    window.open(path);
  }
}

//////////////////////////////
// 年级单选改变事件
function change1(val) {
  // 赋值
  mydata.form.grade_id = val;
  // console.log(mydata.filterButton1,"121212")
  // 查询
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
}

// 学科单选框改变事件
function change2(val) {
  mydata.form.subject_id = val;
  // 查询
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
}

// 地区单选改变事件
function change3(val) {
  // 赋值
  mydata.form.address_id = val;
  // console.log(mydata.filterButton1,"121212")
  // 查询
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
}

// 类型单选框改变事件
function change4(val) {
  mydata.form.type_id = val;
  // 查询
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
}
// 年份单选改变事件
function change5(val) {
  // 赋值
  mydata.form.year_id = val;
  // console.log(mydata.filterButton1,"121212")
  // 查询
  // getData();
  // 跳转到高级搜索页面
  goSeniorSearch();
}

// getData();

function goSeniorSearch() {
  router.push({
    path: "/layout/list/listenBig",
    query: {
      grade_id: mydata.form.grade_id,
      subject_id: mydata.form.subject_id,
      address_id: mydata.form.address_id,
      type_id: mydata.form.type_id,
      year_id: mydata.form.year_id,
      search: mydata.form.search,
    },
  });
}

// 底部推荐数据
function getBottomRecommendData() {
  // // 调用接口
  // examSearchList({
  //   search: "", // 搜索查询
  //   grade_id: "", // 年级
  //   subject_id: "", //学科
  //   address_id: "", //地区
  //   type_id: "", //类型
  //   year_id: "", // 年份
  //   is_new: "", //是否最新（不传或者传0：否，1：是）
  //   is_recommended: "1", //是否推荐（不传或者传0：否，1：是）
  // }).then((res) => {
  //   mydata.recommend_list = res.data.list;

  // });

  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord["必备好书"];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.recommend_list = res.data.list;
  });
}
// getBottomRecommendData();

function goInfoPage(id) {
  router.push({
    path: "/layout/list/topicSubjectDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p {
    cursor: pointer;
    // border: 1px solid red;
  }
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.box-taobao4,
.box-taobao5 {
  .my-li {
    > p:nth-of-type(1) {
      width: 100%;
    }
  }
}

li:hover {
  p:nth-of-type(2) {
    color: #009de0;
  }
}
////////整体设置column组件
:deep(.box-column) {
  // padding: 30px;
  box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
  ////
  > .column-title {
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    border-bottom: 1px solid #cccccc;
    // border: 1px solid red;
    p {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
    > p:hover {
      color: #009de0 !important;
    }
  }

  li {
    font-size: 14px;
    line-height:24px;
    margin-left: 20px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    margin-bottom: 10px;
    // border:1px solid red;
    position: relative;
    p:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      color: #888888;
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
  li:nth-last-of-type(1) {
    margin-bottom: 0px;
  }

  li:hover {
    p:nth-of-type(2) {
      color: #009de0;
    }
  }
  .column-content {
    // height:100%;
    height: 200px;
    // margin-top: 30px;
    overflow: hidden;
    // border: 1px solid rgb(43, 255, 0);
  }
}

.boxTB {
  background-color: #f9f9f9;
  padding-bottom: 40px;
  overflow: visible;
  // ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }
  
  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }

 //////模块1------筛选按钮
  .box-taobao1 {
    // width: 343px !important;
    // height: 184px;
    // border: 1px solid rgb(0, 115, 255);
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 16px 0px;
    overflow: hidden;
    // border-radius: 8px;
  }
  ///////模块2------最新上传 + 数据一览
  .box-taobao2 {
    margin: 0 auto;
    margin-bottom: 16px;
    overflow: hidden;
    :deep(.box-column) {
      height: 100%;
      margin-bottom: 16px;
      background: linear-gradient(
        180deg,
        #fdeff1 0%,
        rgba(255, 255, 255, 0.2) 145px,
        #ffffff 100%
      );
    }

    //数据一栏
    .data-box {
      margin: 0 auto;
    }
  }

  
   ///////模块4------高一、高二、高三;初一、初二、初三
  .box-taobao4,
  .box-taobao5 {
    background-color: #ffffff;
    // border-radius: 8px;
    // border:1px solid red;
    margin-top: 16px;
    margin-bottom: 16px;
    .book-list {
      // border: 1px solid rgb(0, 4, 255);
      ///////整体宽度(目录 + 内容)
      :deep(.el-tabs.el-tabs--top.demo-tabs) {
        // border: 1px solid rgb(30, 255, 0);
        width: 343px;
        margin: 0 auto;
        padding-bottom: 16px;
        // margin-top: 16px;
      }
      // 内容
      :deep(.demo-tabs > .el-tabs__content) {
        height: 200px;
        // border: 1px solid red;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0px;
        padding-bottom: 15px;
        overflow-y: auto;
      }

      //////每个目录的宽度
      :deep(.el-tabs__item.is-top) {
        width: 114px;
        height: 56px;
        text-align: center;
        padding: 0px;
        // border: 1px solid rgb(89, 0, 255);
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 1px;
        // margin:0 auto;
        // color:#333333;
      }

      li:hover {
        p:nth-of-type(2) {
          color: #009de0;
        }
      }

      li {
        margin-left: 20px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        margin-bottom: 10px;
        // border: 1px solid red;
        position: relative;
        p:first-of-type {
          font-size: 14px;
          margin-bottom: 10px;
          line-height: 24px;
          white-space: nowrap; //不折行
          text-overflow: ellipsis; //文本溢出 用省略号显示
          overflow: hidden;
        }
        p:nth-of-type(2) {
          font-size: 14px;
          font-weight: 400;
          color: #888888;
          position: absolute;
          right: 0px;
          top: 0px;
        }
      }
      li:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }
}



///////模块6------初一、初二、初三
.box-taobao6 {
  // width: 1200px;
  // height: 462px;
  // border: 1px solid rgb(60, 255, 0);
  background: linear-gradient(
    180deg,
    #dcf5ff 0%,
    rgba(255, 255, 255, 0.2) 145px,
    #ffffff 100%
  );
  margin: 0 auto;
  // margin-bottom: 50px;
  // display: flex;
  // justify-content: space-between;
  overflow: hidden;
  overflow: visible;
  padding: 30px 0px 20px 0px;
  > img {
    width: 307px;
    height: 50px;
    // border:1px solid red;
    margin: 0 auto;
    margin-bottom: 30px;
    display: block;
  }
  // .img-box {
  //   height: 270px;
  //   // border:1px solid blue;
  //   display: flex;
  //   justify-content: space-between;
  //   // margin-bottom:52px;
  // }
}


:deep(.r-btn[data-v-1891c10e]){
   right: 0px;
}

:deep(.l-btn[data-v-1891c10e]){
  left:0px;
}
</style>
